import typeImg1 from './assets/type1.png';
import typeImg2 from './assets/type2.png';
import typeImg3 from './assets/type3.png';
import typeImg4 from './assets/type4.png';
import typeImg5 from './assets/type5.png';
import './App.css';
import HeaderComponent from './components/Header';
import FooterComponent from './components/Footer';
import RecommendSideBar from './components/RecommendSidebar';
import HotSideBar from './components/HotSidebar';
import React, { useState, useEffect, useRef } from 'react';
import { Flex, Layout, Table, Tabs, Row, Col, message, Modal } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import unit from './unit';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
const { Content } = Layout;
 
const Detail = (props) => {
    const navigate = useNavigate();
    const location = useLocation(); // 新增：用于监听路由变化
    const [page, setPage] = useState(1);
    const [pagecount, setPagecount] = useState(50);
    const [name, setName] = useState('');
    const [isFollow, setIsFollow] = useState(0);
    const [icon, setIcon] = useState('');
    const [loading, setLoading] = useState(true);
    const [columns, setColumns] = useState([]);
    const [activeKey, setActiveKey] = useState('');
    const [dataSource, setDataSource] = useState([]);
    const [tabsItems, setTabsItems] = useState([]);
    const [typeItems, setTypeItems] = useState([]);
    const [tagItems, setTagItems] = useState([]);
    const { code } = useParams();
    const childRef = useRef(null);
    const [sortField, setSortField] = useState('shizhi');
    const [sortOrder, setSortOrder] = useState('descend');
    const [total, setTotal] = useState(0);
    const [filterType, setFilterType] = useState('全部');
    const [type, setType] = useState(1);
    const [convertedType, setConvertedType] = useState();
    const [messageApi, contextHolder] = message.useMessage();
    const [modal, modalContextHolder] = Modal.useModal();
    const [lastClickedCode, setLastClickedCode] = useState(null);
    const [tips2, setTips2] = useState('');
    const [currentTabText, setCurrentTabText] = useState('');
    const isFirstLoad = useRef(true);

    // 打开关注弹窗
    const floatAdClick = () => {
        childRef.current?.handleFloatingBallClick();
    }

    // 处理表格排序和分页变化
    const handleTableChange = (pagination, filters, sorter) => {
        setSortField(sorter.field);
        setSortOrder(sorter.order);
        setPage(pagination.current);
        setPagecount(pagination.pageSize);
    };

    // 关注/取消关注功能
    const followFunc = () => {
        const path = isFollow ? '/pc/gudong/unfollow' : '/pc/gudong/follow';
        
        if (childRef.current) {
            const isLoggedIn = unit.getToken();
            
            if (isLoggedIn) {
                unit.httpGet(path, {
                    "code": code,
                    "type": 1,
                    "apiversion": "8.9"
                }, (data) => {
                    setIsFollow(!isFollow);
                    if (isFollow) {
                        // 已取消关注，去掉图标
                        messageApi.open({
                            type: "Warning",
                            content: "已取消关注",
                            icon: null // 去掉图标
                        });
                    } else {
                        // 已关注，保留默认图标
                        messageApi.open({
                            type: "success",
                            content: "已关注"
                        });
                    }
                }, (code, msg) => {
                    messageApi.open({ type: "error", content: msg });
                });
            } else {
                childRef.current.onLogin();
            }
        }
    };

    // 处理标签点击事件
    const onTagClick = (v) => {
        setFilterType(v);
        setPage(1); // 重置页码为1
    };

    // 处理Tab切换事件
    const onTabsChange = (activeKey) => {
        setActiveKey(Number(activeKey)); // 转换为数字类型
        setPage(1); // 重置页码为1
        
        // 更新当前选中的tab文本
        const selectedTab = tabsItems.find(tab => tab.key === activeKey);
        if (selectedTab) {
            setCurrentTabText(selectedTab.label);
        }
    };

    // 格式化表格数据
    const formatTableData = (data, columns) => {
        return data.map(item => {
            const formattedItem = {};
            
            // 表头中股票代码和名称是第一列，但实际数据中它们合并在第一个元素中
            const stockInfoArr = item[0]?.text.split("#") || [];
            formattedItem['stock_code'] = stockInfoArr[1];
            formattedItem['stock_name'] = stockInfoArr[0];
            
            // 从第二个表头列开始映射（跳过已处理的股票代码/名称）
            columns.slice(2).forEach((column, j) => {
                const val = column.dataIndex;
                // 注意：实际数据索引 = 表头索引 + 1（因为股票代码/名称合并在第一个元素中）
                const dataIndex = j + 1;
                
                if (item[dataIndex]) {
                    const text = item[dataIndex].text || '';
                    
                    if (val === 'change_num_rate') {
                        // 处理增减比例样式
                        if (text === '新进') {
                            formattedItem[val] = <span className="newColor">{text}</span>;
                        } else if (text[0] === '+') {
                            formattedItem[val] = <span className="addColor">{text}</span>;
                        } else if (text[0] === '-') {
                            formattedItem[val] = <span className="delColor">{text}</span>;
                        } else {
                            formattedItem[val] = text;
                        }
                    } else if (val === 'change_num') {
                        // 处理增减数量样式
                        if (text[0] === '+') {
                            formattedItem[val] = <span className="addColor">{text}</span>;
                        } else if (text[0] === '-') {
                            formattedItem[val] = <span className="delColor">{text}</span>;
                        } else {
                            formattedItem[val] = text;
                        }
                    } else if (val === 'hold_num' || val === 'hold_rate') {
                        // 数值类型
                        formattedItem[val] = parseFloat(text);
                    } else {
                        // 其他类型
                        formattedItem[val] = text;
                    }
                }
            });
            
            return formattedItem;
        });
    };

    // 获取详情列表数据
    const getDetailList = () => {
        setLoading(true);
        let order = sortOrder === 'ascend' ? 'asc' : 'desc';
        const path = '/dxwapp/gegu/guDongDetail';
        
        unit.httpGet(path, {
            "code": code,
            "date": activeKey,
            "filter_type": filterType,
            "page": page,
            "pagecount": pagecount,
            "apiversion": "8.9",
            "orderKey": sortField,
            "orderValue": order,
        }, (data) => {
            const header = data.list?.head_info || [];
            const title = data.title || '';
            const type = data.type || '';
            const tips2Text = data.tips2 || '';
            setTips2(tips2Text);
            setType(type);
            setIsFollow(data.is_follow || 0);
            
            // 处理标签页数据
            const tabsItems = (data.tab_list || []).map(tab => ({
                key: tab.v,
                label: tab.t
            }));
            setTabsItems(tabsItems);
            
            // 设置当前选中的tab文本
            if (tabsItems.length > 0) {
                const initialTab = tabsItems.find(tab => tab.key === activeKey) || tabsItems[0];
                setCurrentTabText(initialTab.label);
                // 如果是首次加载或没有选中的tab，设置默认选中的tab
                if (activeKey === '' || !tabsItems.some(tab => tab.key === activeKey)) {
                    setActiveKey(initialTab.key);
                }
            }
            
            // 处理类型数据
            const typeItems = [{
                k: "持仓家数",
                v: data.holder_count_list?.holder_count || 0,
                c: "#333333"
            }].concat(
                (data.holder_count_list?.holder_list || []).map(item => ({
                    k: item.t,
                    v: item.v,
                    c: item.color
                }))
            );
            setTypeItems(typeItems);
            
            // 处理筛选标签数据
            const tagItems = (data.filter_type || []).map(item => ({
                k: item.t,
                v: item.v,
                current: item.current
            }));
            setTagItems(tagItems);
            
            // 处理表格列数据
            const newColumns = [];
            
            header.forEach((item, i) => {
                const column = {
                    title: i === 0 ? "股票代码" : item.text,
                    dataIndex: i === 0 ? "stock_code" : item.sort_key,
                    key: i,
                    align: i <= 1 ? 'left' : 'center', // 前两列左对齐，其余居中
                    sortDirections: ['descend', 'ascend', 'descend']
                };
                
                if (i === 0) {
                    // 股票代码列
                    newColumns.push(column);
                    
                    // 股票名称列
                    newColumns.push({
                        title: "股票名称",
                        dataIndex: "stock_name",
                        key: i + 1,
                        align: 'left',
                        render: (text, record) => (
                            <a 
                                target="_blank" 
                                href={`/particulars/${record.stock_code}`} 
                                onClick={() => setLastClickedCode(record.stock_code)} 
                                style={{ textDecoration: lastClickedCode === record.stock_code ? 'underline' : 'none' }}
                            >
                                {text}
                            </a>
                        )
                    });
                } else {
                    // 其他列
                    if (item.sort === 1) {
                        column.sorter = true;
                        column.sortOrder = sortField === item.sort_key ? sortOrder : null;
                    }
                    
                    // 关注查看列
                    if (item.sort_key === 'cost') {
                        column.render = (text, record) => {
                            if (record.cost === '关注查看') {
                                return <span className="text-primary">{text}</span>;
                            } else if (record.cost === '查看') {
                                return <span className="text-primary">{text}</span>;
                            }
                            return text;
                        };
                        column.onCell = (record) => ({
                            onClick: (event) => {
                                if (record.cost === '关注查看') {
                                    floatAdClick();
                                    event.stopPropagation();
                                } else if (record.cost === '查看') {
                                    modal.info({
                                        icon: null,
                                        title: (
                                            <span style={{ display: 'flex', alignItems: 'center', gap: 8, fontWeight: 600 }}>
                                                <InfoCircleOutlined style={{ color: '#1677ff' }} />
                                                温馨提示
                                            </span>
                                        ),
                                        content: (
                                            <div style={{ padding: '8px 0 4px', lineHeight: 1.7 }}>
                                                请前往<span style={{ color: '#1677ff', fontWeight: 500 }}>天鹰云策电脑版</span>或<span style={{ color: '#1677ff', fontWeight: 500 }}>汇金智投APP</span>内查看
                                            </div>
                                        ),
                                        okText: '我知道了',
                                        okButtonProps: {
                                            size: 'small',
                                            style: {
                                                borderRadius: 16,
                                                height: 30,
                                                paddingInline: 20,
                                                fontSize: 14,
                                                background: 'linear-gradient(90deg,#1677ff 0%,#4096ff 100%)',
                                                boxShadow: '0 2px 8px rgba(22,119,255,0.25)',
                                            },
                                        },
                                        centered: true,
                                        width: 380,
                                    });
                                    event.stopPropagation();
                                }
                            }
                        });
                    }
                    
                    // 盈亏列
                    if (item.sort_key === 'profit') {
                        column.render = (text) => {
                            if (text && text[0] === '+') {
                                return <span className="addColor">{text}</span>;
                            } else if (text && text[0] === '-') {
                                return <span className="delColor">{text}</span>;
                            }
                            return text;
                        };
                    }
                    
                    newColumns.push(column);
                }
            });
            
            // 处理表格数据源
            const newDataSource = formatTableData(data.list?.list || [], newColumns);
            
            // 设置图标类型
            let icon;
            let convertedType;
            let typeName;
            
            switch (type) {
                case "7":
                case "8":
                case "9":
                case "10":
                    convertedType = "institution";
                    typeName = "机构";
                    icon = typeImg1;
                    break;
                case "1":
                    convertedType = "niusan";
                    typeName = "牛散";
                    icon = typeImg2;
                    break;
                case "2":
                    convertedType = "fund";
                    typeName = "基金";
                    icon = typeImg3;
                    break;
                case "3":
                case "4":
                case "5":
                    convertedType = "nationalteam";
                    typeName = "国家队";
                    icon = typeImg4;
                    break;
                case "6":
                    convertedType = "foreigncapital";
                    typeName = "外资";
                    icon = typeImg5;
                    break;
                default:
                    typeName = "未知类型";
            }
            
            setLoading(false);
            setName(title);
            setColumns(newColumns);
            setDataSource(newDataSource);
            setTotal(parseInt(data.holder_count_list?.holder_count || 0));
            setConvertedType(convertedType);
            setIcon(icon);
            
            // 更新页面标题和meta描述
            updatePageMeta(title, typeName, currentTabText);
        }, () => {
            // 请求失败时也关闭加载状态
            setLoading(false);
        });
    };

    // 更新页面标题和meta描述
    const updatePageMeta = (entityName, entityType, timePeriod) => {
        // 设置页面标题
        document.title = `${entityName}${entityType}持仓数据${timePeriod ? ' - ' + timePeriod : ''} - 仓位在线`;
        
        // 设置meta描述
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
            metaDescription.setAttribute('content', 
                `${entityName}${entityType}最新持仓数据${timePeriod ? '（' + timePeriod + '）' : ''}，` +
                `包括持仓股票、持股数量、持仓比例、持仓成本等信息，全面掌握${entityName}${entityType}的投资布局。`
            );
        }
    };

    // 主要修改：添加监听路由变化的effect，确保每次进入页面都重新加载数据
    useEffect(() => {
        // 无论是否是首次加载，只要路由变化（进入页面）就重新获取数据
        getDetailList();
        
        // 首次加载后更新标记
        if (isFirstLoad.current) {
            isFirstLoad.current = false;
        }
    }, [location.pathname]); // 仅依赖路由路径，确保每次进入页面都执行

    // 处理筛选条件变化时重新获取数据
    useEffect(() => {
        // 非首次加载时，当筛选条件变化才重新获取数据
        if (!isFirstLoad.current) {
            getDetailList();
        }
    }, [filterType, activeKey, page, pagecount, sortField, sortOrder]);

    // 监听currentTabText变化，更新页面meta信息
    useEffect(() => {
        if (name) {
            let typeName;
            
            switch (type) {
                case "7":
                case "8":
                case "9":
                case "10":
                    typeName = "机构";
                    break;
                case "1":
                    typeName = "牛散";
                    break;
                case "2":
                    typeName = "基金";
                    break;
                case "3":
                case "4":
                case "5":
                    typeName = "国家队";
                    break;
                case "6":
                    typeName = "外资";
                    break;
                default:
                    typeName = "未知类型";
            }
            
            updatePageMeta(name, typeName, currentTabText);
        }
    }, [currentTabText, name, type]);

    return (
        <div className="App">
            <Flex gap="middle" wrap>
                <Layout>
                    <HeaderComponent ref={childRef} />
                    <Content>
                        <Row style={{ padding: '20px' }}>
                            <Col span={18} style={{ background: '#FFFFFF' }}>
                                <div className='detail'>
                                    <div className='content'>
                                        <div className='left'>
                                            {icon ? <img src={icon} className='jigou' alt="机构类型图标" /> : ''}
                                        </div>
                                        <div className='left' style={{ marginLeft: "8px" }}>
                                            {contextHolder}
                                            {modalContextHolder}
                                            <div className='name'>{name}</div>
                                            {isFollow ? (
                                                <div onClick={followFunc} className='follow followed' style={{ cursor: "pointer" }}>
                                                    <span>已关注</span>
                                                </div>
                                            ) : (
                                                <div onClick={followFunc} className='follow unfollow' style={{ cursor: "pointer" }}>
                                                    <span> + 关注</span>
                                                </div>
                                            )}
                                        </div>
                                        <div className='clear'></div>
                                    </div>
                                </div>
                                <div className="tabs-container">
                                    <Tabs activeKey={activeKey || tabsItems[0]?.key || '1'} items={tabsItems} onChange={onTabsChange} />
                                </div>
                                <div className='type-container'>
                                    <Row>
                                        {typeItems.length > 0 ? typeItems.map((item, index) => (
                                            <Col key={index} style={{ width: '20%', background: index === 0 ? "#f8f8f8" : "unset" }}>
                                                <div className='type-top' style={{ color: item.c }}>{item.v}</div>
                                                <div className='type-bottom'>{item.k}</div>
                                            </Col>
                                        )) : ''}
                                    </Row>
                                </div>
                                <div className='body' style={{ background: '#FFFFFF', padding: "0px 0px 10px 0px" }}>
                                    <div className='row'>
                                        <div className='left title'>持仓明细</div>
                                        {tips2 && (<div className='right-title'>{tips2}</div>)}
                                        <div className='right update_time'></div>
                                        <div className='clear'></div>
                                    </div>
                                    <div className='tag-container'>
                                        <Flex gap="small" wrap>
                                            {tagItems.length > 0 ? tagItems.map((item, index) => (
                                                <span 
                                                    key={index} 
                                                    onClick={() => onTagClick(item.v)} 
                                                    className={filterType === item.v ? "tag active" : "tag"}
                                                >
                                                    {item.k}
                                                </span>
                                            )) : ''}
                                        </Flex>
                                    </div>
                                    <div className='table'>
                                        <Table 
                                            size='small' 
                                            loading={loading} 
                                            locale={{ 
                                                cancelSort: "点击取消排序", 
                                                triggerAsc: "点击升序", 
                                                triggerDesc: "点击降序", 
                                                emptyText: "暂无数据" 
                                            }} 
                                            pagination={{
                                                current: page,
                                                pageSize: pagecount,
                                                total: total,
                                                showSizeChanger: false,
                                                showQuickJumper: true,
                                                locale: {
                                                    jump_to: '跳至',
                                                    jump_to_confirm: '确定',
                                                    page: '页',
                                                    prev_page: '上一页',
                                                    next_page: '下一页'
                                                }
                                            }}
                                            columns={columns} 
                                            dataSource={dataSource} 
                                            rowClassName="custom-row"
                                            onChange={handleTableChange}
                                        />
                                    </div>
                                </div>
                            </Col>
                            <Col span={6}>
                                <div className='sidebar-container'>
                                    <HotSideBar type={convertedType} />
                                    <div style={{ marginTop: "15px" }}></div>
                                    <RecommendSideBar type={convertedType} />
                                </div>
                            </Col>
                        </Row>
                    </Content>
                    <FooterComponent />
                </Layout>
            </Flex>
        </div>
    );
};

export default Detail;
